import React from 'react';
export const useWillMount = (effect, deps) => {
  const initialized = React.useRef(false);
  const returnHandler = React.useRef();
  React.useEffect(() => {
    return () => {
      returnHandler.current == null ? void 0 : returnHandler.current();
      initialized.current = false;
    };
  }, []);
  React.useEffect(() => {
    if (deps != null && deps.length) {
      initialized.current = false;
    }
  }, deps);
  if (!initialized.current) {
    initialized.current = true;
    const returnValue = effect();
    returnHandler.current = typeof returnValue === 'function' ? returnValue : undefined;
  }
};
//# sourceMappingURL=useWillMount.js.map